<template>
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.94 9.86C4.52026 9.86 4.18 9.51974 4.18 9.1V5.62H0.74C0.331309 5.62 0 5.28869 0 4.88C0 4.47131 0.331309 4.14 0.74 4.14H4.18V0.760001C4.18 0.340264 4.52026 0 4.94 0C5.35974 0 5.7 0.340264 5.7 0.76V4.14H9.14C9.54869 4.14 9.88 4.47131 9.88 4.88C9.88 5.28869 9.54869 5.62 9.14 5.62H5.7V9.1C5.7 9.51974 5.35974 9.86 4.94 9.86Z"
      fill="#040325"
    />
  </svg>
</template>
